import { render, staticRenderFns } from "./IrisDisplayInputFieldKeypad.vue?vue&type=template&id=0122d7f3&"
import script from "./IrisDisplayInputFieldKeypad.vue?vue&type=script&lang=ts&"
export * from "./IrisDisplayInputFieldKeypad.vue?vue&type=script&lang=ts&"
import style0 from "./IrisDisplayInputFieldKeypad.vue?vue&type=style&index=0&id=0122d7f3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports